/*
 * Created on Mon Jun 28 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 */

import Logo24 from "./assets/images/icons/pink-logo-24.png";
import Avatar from "./assets/images/icons/avatar.png";
import Avatar2 from "./assets/images/desktop/zine-avatar13.png";
import Artwork from "./assets/images/icons/artwork.png";
import { images } from './constants';

export const fakeEmails = ['user1@gmail.com', 'user2@gmail.com', 'user3@gmail.com', 'khorkch01@gmail.com', 'bynlin.work@gmail.com'];
export const fakeFirstname = 'Alethea';
export const fakeLastname = 'Jayne';
export const fakePasswords = ['user1', 'user2', 'user3', 'khorkch01', 'bynlin'];

export const notifications = [
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "2 weeks ago",
        artwork: Artwork
    },
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "2 weeks ago",
        artwork: Artwork
    },
    {
        link: '#',
        src: Avatar,
        note: "<span>Michelle Lim</span> just followed you!",
        timestamp: "2 weeks ago",
        artwork: ''
    },
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "2 weeks ago",
        artwork: Artwork
    },
    {
        link: '#',
        src: Avatar,
        note: "<span>Michelle Lim</span> just followed you!",
        timestamp: "2 weeks ago",
        artwork: ''
    },
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "7 hours ago",
        artwork: Artwork
    },
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "7 hours ago",
        artwork: Artwork
    },
    {
        link: '#',
        src: Avatar,
        note: "<span>Michelle Lim</span> just followed you!",
        timestamp: "7 hours ago",
        artwork: ''
    },
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "7 hours ago",
        artwork: Artwork
    },
    {
        link: '#',
        src: Avatar,
        note: "<span>Michelle Lim</span> just followed you!",
        timestamp: "7 hours ago",
        artwork: Artwork
    },
    {
        link: '#',
        src: Avatar,
        note: "<span>Michelle Lim</span> just followed you!",
        timestamp: "4 minutes ago",
        artwork: Artwork
    },
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "4 minutes ago",
        artwork: Artwork
    },
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "4 minutes ago",
        artwork: Artwork
    },
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "2 weeks ago",
        artwork: Artwork
    },
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "2 weeks ago",
        artwork: Artwork
    },
    {
        link: '#',
        src: Avatar,
        note: "<span>Michelle Lim</span> just followed you!",
        timestamp: "2 weeks ago",
        artwork: ''
    },
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "2 weeks ago",
        artwork: Artwork
    },
    {
        link: '#',
        src: Avatar,
        note: "<span>Michelle Lim</span> just followed you!",
        timestamp: "2 weeks ago",
        artwork: ''
    },
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "7 hours ago",
        artwork: Artwork
    },
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "7 hours ago",
        artwork: Artwork
    },
    {
        link: '#',
        src: Avatar,
        note: "<span>Michelle Lim</span> just followed you!",
        timestamp: "7 hours ago",
        artwork: ''
    },
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "7 hours ago",
        artwork: ''
    },
    {
        link: '#',
        src: Avatar,
        note: "<span>Michelle Lim</span> just followed you!",
        timestamp: "7 hours ago",
        artwork: ''
    },
    {
        link: '#',
        src: Avatar,
        note: "<span>Michelle Lim</span> just followed you!",
        timestamp: "4 minutes ago",
        artwork: ''
    },
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "4 minutes ago",
        artwork: Artwork
    },
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "4 minutes ago",
        artwork: ''
    },
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "7 hours ago",
        artwork: Artwork
    },
    {
        link: '#',
        src: Avatar,
        note: "<span>Michelle Lim</span> just followed you!",
        timestamp: "7 hours ago",
        artwork: ''
    },
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "7 hours ago",
        artwork: ''
    },
    {
        link: '#',
        src: Avatar,
        note: "<span>Michelle Lim</span> just followed you!",
        timestamp: "7 hours ago",
        artwork: ''
    },
    {
        link: '#',
        src: Avatar,
        note: "<span>Michelle Lim</span> just followed you!",
        timestamp: "4 minutes ago",
        artwork: ''
    },
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "4 minutes ago",
        artwork: Artwork
    },
    {
        link: '#',
        src: Logo24,
        note: "Your article, <span>Article Title</span>, is now live on itch!",
        timestamp: "4 minutes ago",
        artwork: ''
    }
]

export const fakeFacename = [
    {
        firstname: 'Kelly Ann',
        id: 'af12a735af27dd211b0d0cca8df31a30'
    },
    {
        firstname: 'Kelly Annnnnnnnnnnnnnnnnn',
        id: '1b0d0cca8df31a30af12a735af27dd21'
    }
]

const tints = ['black', 'white', 'pink'];
const randomInt = Math.floor(Math.random() * 3);
export const featured = {
    index: 100,
    tint: tints[randomInt],
    author: 'kristina okan',
    occupation: 'Fashion artist / Creative director, Stylist',
    location: 'Russia',
    cover: images['zine-featured.png'],
    profile: images['zine-avatar13.png'],
    video: '',
    statement: `Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe ipsum eveniet ut et voluptates repudian aliquati umi sint non recusandae. Cras luctus ante laoreet erat varius rhoncus. Nulla dapibus turpis vel elit varius, vel fringilla felis tempus. Sed id nisi id elit luctus fringilla. Aenean sit amet tristique vulputate dolor sollicitudin at. Mauris nisi iliusi odio, consequat rutrum odio lacinia.
    <br/>
    <br/>
    Morbi vel congue justo, sed venenatis libero. Donec quis metus viverra, vehicula eros ac, porttitor tortor. Proin blandit semper amet ex a volutpat. Phasellus ac ipsum vestibulum, congue neque vel, accumsan elit. Aliquam eleifend mattis rutrum. Vivamus nunc sapien, imperdiet a turpis id, volutpat porta enim.
    `,
    title: 'Blossom',
    description: `Editorial for Afi Magazine
    Photographer: @marcos_rodriguezvelo
    Creative director: @kristina_okan
    Makeup&Hairs: @isabelsophiemakeup
    Stylist/set designer: @kristina_okan
    Model:@shari.jnd at @beautymodelmgmt`,
    // quote: "quote",
    tags: ['Pioneers', 'Interview', 'Creative Process'],
    date: '11 April 2022',
    time: '4.56am'
}
export const featured2 = {
    index: 100,
    tint: tints[randomInt],
    author: 'kristina okan',
    occupation: 'Fashion artist / Creative director, Stylist',
    location: 'Russia',
    cover: images['video_scrnsht.png'],
    profile: images['zine-avatar13.png'],
    video: 'https://player.vimeo.com/video/576658110?autoplay=1&title=0&byline=0&badge=0&portrait=0',
    statement: `Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe ipsum eveniet ut et voluptates repudian aliquati umi sint non recusandae. Cras luctus ante laoreet erat varius rhoncus. Nulla dapibus turpis vel elit varius, vel fringilla felis tempus. Sed id nisi id elit luctus fringilla. Aenean sit amet tristique vulputate dolor sollicitudin at. Mauris nisi iliusi odio, consequat rutrum odio lacinia.
    <br/>
    <br/>
    Morbi vel congue justo, sed venenatis libero. Donec quis metus viverra, vehicula eros ac, porttitor tortor. Proin blandit semper amet ex a volutpat. Phasellus ac ipsum vestibulum, congue neque vel, accumsan elit. Aliquam eleifend mattis rutrum. Vivamus nunc sapien, imperdiet a turpis id, volutpat porta enim.
    `,
    title: 'Blossom',
    description: `Editorial for Afi Magazine
    Photographer: @marcos_rodriguezvelo
    Creative director: @kristina_okan
    Makeup&Hairs: @isabelsophiemakeup
    Stylist/set designer: @kristina_okan
    Model:@shari.jnd at @beautymodelmgmt`,
    // quote: "quote",
    tags: ['Pioneers', 'Interview', 'Creative Process'],
    date: '11 April 2022',
    time: '4.56am'
}
export const archives = [
    {
        index: 100,
        tint: tints[randomInt],
        author: 'kristina okan',
        occupation: 'Fashion artist / Creative director, Stylist',
        location: 'Singapore',
        cover: images['zine-featured.png'],
        profile: images['zine-avatar13.png'],
        video: '',
        statement: `Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe ipsum eveniet ut et voluptates repudian aliquati umi sint non recusandae. Cras luctus ante laoreet erat varius rhoncus. Nulla dapibus turpis vel elit varius, vel fringilla felis tempus. Sed id nisi id elit luctus fringilla. Aenean sit amet tristique vulputate dolor sollicitudin at. Mauris nisi iliusi odio, consequat rutrum odio lacinia.
        <br/>
        <br/>
        Morbi vel congue justo, sed venenatis libero. Donec quis metus viverra, vehicula eros ac, porttitor tortor. Proin blandit semper amet ex a volutpat. Phasellus ac ipsum vestibulum, congue neque vel, accumsan elit. Aliquam eleifend mattis rutrum. Vivamus nunc sapien, imperdiet a turpis id, volutpat porta enim.
        `,
        title: 'Blossom',
        description: `Editorial for Afi Magazine
        Photographer: @marcos_rodriguezvelo
        Creative director: @kristina_okan
        Makeup&Hairs: @isabelsophiemakeup
        Stylist/set designer: @kristina_okan
        Model:@shari.jnd at @beautymodelmgmt`,
        // quote: "quote",
        tags: ['Pioneers', 'Interview', 'Creative Process'],
        date: '11 April 2022',
        time: '4.56am'
    },
    {
        index: 99,
        tint: tints[randomInt],
        author: 'kristina okan',
        occupation: 'Fashion artist / Creative director, Stylist',
        location: 'Russia',
        cover: images['zine-artwork1.jpg'],
        profile: images['zine-avatar12.png'],
        video: '',
        statement: `Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe ipsum eveniet ut et voluptates repudian aliquati umi sint non recusandae. Cras luctus ante laoreet erat varius rhoncus. Nulla dapibus turpis vel elit varius, vel fringilla felis tempus. Sed id nisi id elit luctus fringilla. Aenean sit amet tristique vulputate dolor sollicitudin at. Mauris nisi iliusi odio, consequat rutrum odio lacinia.
        <br/>
        <br/>
        Morbi vel congue justo, sed venenatis libero. Donec quis metus viverra, vehicula eros ac, porttitor tortor. Proin blandit semper amet ex a volutpat. Phasellus ac ipsum vestibulum, congue neque vel, accumsan elit. Aliquam eleifend mattis rutrum. Vivamus nunc sapien, imperdiet a turpis id, volutpat porta enim.
        `,
        title: 'Blossom',
        description: `Editorial for Afi Magazine
        Photographer: @marcos_rodriguezvelo
        Creative director: @kristina_okan
        Makeup&Hairs: @isabelsophiemakeup
        Stylist/set designer: @kristina_okan
        Model:@shari.jnd at @beautymodelmgmt`,
        // quote: "quote",
        tags: ['Pioneers', 'Interview', 'Creative Process'],
        date: '11 April 2022',
        time: '4.56am'
    },
    {
        index: 98,
        tint: tints[randomInt],
        author: 'kristina okan',
        occupation: 'Fashion artist / Creative director, Stylist',
        location: 'SG',
        cover: images['zine-artwork2.jpg'],
        profile: images['zine-avatar14.png'],
        video: '',
        statement: `Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe ipsum eveniet ut et voluptates repudian aliquati umi sint non recusandae. Cras luctus ante laoreet erat varius rhoncus. Nulla dapibus turpis vel elit varius, vel fringilla felis tempus. Sed id nisi id elit luctus fringilla. Aenean sit amet tristique vulputate dolor sollicitudin at. Mauris nisi iliusi odio, consequat rutrum odio lacinia.
        <br/>
        <br/>
        Morbi vel congue justo, sed venenatis libero. Donec quis metus viverra, vehicula eros ac, porttitor tortor. Proin blandit semper amet ex a volutpat. Phasellus ac ipsum vestibulum, congue neque vel, accumsan elit. Aliquam eleifend mattis rutrum. Vivamus nunc sapien, imperdiet a turpis id, volutpat porta enim.
        `,
        title: 'Blossom',
        description: `Editorial for Afi Magazine
        Photographer: @marcos_rodriguezvelo
        Creative director: @kristina_okan
        Makeup&Hairs: @isabelsophiemakeup
        Stylist/set designer: @kristina_okan
        Model:@shari.jnd at @beautymodelmgmt`,
        // quote: "quote",
        tags: ['Pioneers', 'Interview', 'Creative Process'],
        date: '11 April 2022',
        time: '4.56am'
    },
    {
        index: 97,
        tint: tints[randomInt],
        author: 'kristina okan',
        occupation: 'Fashion artist / Creative director, Stylist',
        location: 'US',
        cover: images['zine-artwork3.jpg'],
        profile: images['zine-avatar12.png'],
        video: '',
        statement: `Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe ipsum eveniet ut et voluptates repudian aliquati umi sint non recusandae. Cras luctus ante laoreet erat varius rhoncus. Nulla dapibus turpis vel elit varius, vel fringilla felis tempus. Sed id nisi id elit luctus fringilla. Aenean sit amet tristique vulputate dolor sollicitudin at. Mauris nisi iliusi odio, consequat rutrum odio lacinia.
        <br/>
        <br/>
        Morbi vel congue justo, sed venenatis libero. Donec quis metus viverra, vehicula eros ac, porttitor tortor. Proin blandit semper amet ex a volutpat. Phasellus ac ipsum vestibulum, congue neque vel, accumsan elit. Aliquam eleifend mattis rutrum. Vivamus nunc sapien, imperdiet a turpis id, volutpat porta enim.
        `,
        title: 'Blossom',
        description: `Editorial for Afi Magazine
        Photographer: @marcos_rodriguezvelo
        Creative director: @kristina_okan
        Makeup&Hairs: @isabelsophiemakeup
        Stylist/set designer: @kristina_okan
        Model:@shari.jnd at @beautymodelmgmt`,
        // quote: "quote",
        tags: ['Pioneers', 'Interview', 'Creative Process'],
        date: '11 April 2022',
        time: '4.56am'
    },
    {
        index: 96,
        tint: tints[randomInt],
        author: 'kristina okan',
        occupation: 'Fashion artist / Creative director, Stylist',
        location: 'Russia',
        cover: images['zine-artwork4.jpg'],
        profile: images['zine-avatar10.png'],
        video: '',
        statement: `Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe ipsum eveniet ut et voluptates repudian aliquati umi sint non recusandae. Cras luctus ante laoreet erat varius rhoncus. Nulla dapibus turpis vel elit varius, vel fringilla felis tempus. Sed id nisi id elit luctus fringilla. Aenean sit amet tristique vulputate dolor sollicitudin at. Mauris nisi iliusi odio, consequat rutrum odio lacinia.
        <br/>
        <br/>
        Morbi vel congue justo, sed venenatis libero. Donec quis metus viverra, vehicula eros ac, porttitor tortor. Proin blandit semper amet ex a volutpat. Phasellus ac ipsum vestibulum, congue neque vel, accumsan elit. Aliquam eleifend mattis rutrum. Vivamus nunc sapien, imperdiet a turpis id, volutpat porta enim.
        `,
        title: 'Blossom',
        description: `Editorial for Afi Magazine
        Photographer: @marcos_rodriguezvelo
        Creative director: @kristina_okan
        Makeup&Hairs: @isabelsophiemakeup
        Stylist/set designer: @kristina_okan
        Model:@shari.jnd at @beautymodelmgmt`,
        // quote: "quote",
        tags: ['Pioneers', 'Interview', 'Creative Process'],
        date: '11 April 2022',
        time: '4.56am'
    },
    {
        index: 95,
        tint: tints[randomInt],
        author: 'kristina okan',
        occupation: 'Fashion artist / Creative director, Stylist',
        location: 'Russia',
        cover: images['zine-landscape.jpg'],
        profile: images['zine-avatar13.png'],
        video: '',
        statement: `Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe ipsum eveniet ut et voluptates repudian aliquati umi sint non recusandae. Cras luctus ante laoreet erat varius rhoncus. Nulla dapibus turpis vel elit varius, vel fringilla felis tempus. Sed id nisi id elit luctus fringilla. Aenean sit amet tristique vulputate dolor sollicitudin at. Mauris nisi iliusi odio, consequat rutrum odio lacinia.
        <br/>
        <br/>
        Morbi vel congue justo, sed venenatis libero. Donec quis metus viverra, vehicula eros ac, porttitor tortor. Proin blandit semper amet ex a volutpat. Phasellus ac ipsum vestibulum, congue neque vel, accumsan elit. Aliquam eleifend mattis rutrum. Vivamus nunc sapien, imperdiet a turpis id, volutpat porta enim.
        `,
        title: 'Blossom',
        description: `Editorial for Afi Magazine
        Photographer: @marcos_rodriguezvelo
        Creative director: @kristina_okan
        Makeup&Hairs: @isabelsophiemakeup
        Stylist/set designer: @kristina_okan
        Model:@shari.jnd at @beautymodelmgmt`,
        // quote: "quote",
        tags: ['Pioneers', 'Interview', 'Creative Process'],
        date: '11 April 2022',
        time: '4.56am'
    },
    {
        index: 94,
        tint: tints[randomInt],
        author: 'kristina okan',
        occupation: 'Fashion artist / Creative director, Stylist',
        location: 'Russia',
        cover: images['zine-artwork5.jpg'],
        profile: images['zine-avatar13.png'],
        video: '',
        statement: `Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe ipsum eveniet ut et voluptates repudian aliquati umi sint non recusandae. Cras luctus ante laoreet erat varius rhoncus. Nulla dapibus turpis vel elit varius, vel fringilla felis tempus. Sed id nisi id elit luctus fringilla. Aenean sit amet tristique vulputate dolor sollicitudin at. Mauris nisi iliusi odio, consequat rutrum odio lacinia.
        <br/>
        <br/>
        Morbi vel congue justo, sed venenatis libero. Donec quis metus viverra, vehicula eros ac, porttitor tortor. Proin blandit semper amet ex a volutpat. Phasellus ac ipsum vestibulum, congue neque vel, accumsan elit. Aliquam eleifend mattis rutrum. Vivamus nunc sapien, imperdiet a turpis id, volutpat porta enim.
        `,
        title: 'Blossom',
        description: `Editorial for Afi Magazine
        Photographer: @marcos_rodriguezvelo
        Creative director: @kristina_okan
        Makeup&Hairs: @isabelsophiemakeup
        Stylist/set designer: @kristina_okan
        Model:@shari.jnd at @beautymodelmgmt`,
        // quote: "quote",
        tags: ['Pioneers', 'Interview', 'Creative Process'],
        date: '11 April 2022',
        time: '4.56am'
    }
]
export const articles = [
    {
        id: 9991, // randomly generated 4 digit number
        tint: tints[randomInt],
        type: 'interview',
        title: "from the creators of itch's brand videos:<br/> fashion 2.0",
        subtitle: '',
        description: 'Lorem ipsum dolor sit amet, consectetur aut Hadi Mousally and Olivier Pagny.',
        author: 'Joseph Law',
        occupation: 'itch',
        cover: images['zine-cover1.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: '',
        date: '11 April 2022',
        images: [images['zine-itch-article1.png'], images['zine-itch-article2.png'], images['zine-itch-article3.png'], images['zine-itch-article1.png']],
        imageCaptions: ['Video or image caption aut vitae in <a href="" class="url-underline">Hadi Mousally</a>, tellus venenatis <a href="" class="url-underline">Olivier Pagny</a>.', 'Video or image caption aut vitae in <a href="" class="url-underline">Hadi Mousally</a>, tellus venenatis <a href="" class="url-underline">Olivier Pagny</a>.', 'Video or image caption aut vitae in <a href="" class="url-underline">Hadi Mousally</a>, tellus venenatis <a href="" class="url-underline">Olivier Pagny</a>.', 'Normal image'],
        videoLinks: ['https://player.vimeo.com/video/576658110', 'https://player.vimeo.com/video/576674684', 'https://player.vimeo.com/video/576675937', ''],
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9999, 
        tint: 'black',
        type: '',
        accountType: 'fa',
        title: "today's minds of fashion",
        subtitle: 'Orci varius natoque penatibus et magnisem.',
        description: 'Et harum quidem rerum facilis est et expedita distinctio.',
        author: 'Joseph Law',
        occupation: 'Fashion artist / Creative director',
        location: 'Russia',
        cover: images['zine-cover2.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar14.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9998,
        tint: 'black',
        type: '',
        accountType: 'fc',
        title: 'Elements of Inspiration: Matthildur',
        subtitle: 'Quisque interdum, odio vel dictum posuere.',
        description: '',
        author: 'Lyn Slater',
        occupation: 'Fashion artist / Creative director',
        location: 'Russia',
        cover: images['zine-cover3.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar9.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9997,
        tint: 'white',
        type: '',
        accountType: 'fl',
        title: 'is fashion really going sustainable?',
        subtitle: 'Proin eget hendrerit magna. Sed tortor ligula, risus posuere ut porta vitae, sagittis in augue.',
        description: 'Excepteur sint occaecat cupidatat elitisius.',
        author: 'Joseph Law',
        occupation: 'Fashion artist / Creative director',
        location: 'Russia',
        cover: images['zine-cover4.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar14.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9996,
        tint: 'black',
        type: '',
        accountType: 'fa',
        title: 'How to make your closet more sustainable in 2023',
        subtitle: 'Aenean vitae risus ante laoreet erat varius.',
        description: '',
        author: 'Jessica Wang',
        occupation: 'Fashion lover',
        location: 'Russia',
        cover: images['zine-cover5.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar10.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9995,
        tint: 'pink',
        type: '',
        accountType: 'fa',
        title: 'latest campaign: how does fashion sound like?',
        subtitle: 'Quisque interdum, odio vel dictum posuere.',
        description: 'Nam libero tempore, cum soluta nobis est eligendi optio qui cumque nihil impedit minus id quod maxime placeat facere.',
        author: 'Joseph Law',
        occupation: 'Fashion artist / Creative director',
        location: 'Russia',
        cover: images['zine-cover6.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar14.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9994,
        tint: 'black',
        type: '',
        accountType: 'fa',
        title: 'sounds of a fashion revolution',
        subtitle: 'Curabitur condimentum quam eu erat faucibus, sit amet gravida odio pulvinar.',
        description: 'Itaque earum rerum hic tenetur a sapiente delectus.',
        author: 'Joseph Law',
        occupation: 'Fashion artist / Creative director',
        location: 'Russia',
        cover: images['zine-cover7.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar14.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9993,
        tint: 'white',
        type: '',
        accountType: 'fa',
        title: 'An e-Opening Concern',
        subtitle: 'Quisque interdum, odio vel dictum posuere.',
        description: '',
        author: 'Pressure Culture',
        occupation: 'Fashion company / Brand',
        location: 'Russia',
        cover: images['zine-cover8.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar11.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9992,
        tint: 'pink',
        type: '',
        accountType: 'fa',
        title: "What it's like to apply medicine on fashion.",
        subtitle: 'Aenean vitae risus ante laoreet erat varius.',
        description: '',
        author: "Luis D'oliviera",
        occupation: 'Fashion artist / Creative director, Photographer',
        location: 'Russia',
        cover: images['zine-cover9.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar12.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9991,
        tint: 'black',
        type: '',
        accountType: 'fa',
        title: 'pulling the masks off sustainability',
        subtitle: 'Aenean vitae risus ante laoreet erat varius.',
        description: 'Et harum quidem ut rerum facilis est et expedita ulit distinctio.',
        author: 'Joseph Law',
        occupation: 'Fashion artist / Creative director',
        location: 'Russia',
        cover: images['zine-cover10.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar14.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9990,
        tint: 'pink',
        type: '',
        accountType: 'fa',
        title: 'latest campaign: how does fashion sound like?',
        subtitle: 'Quisque interdum, odio vel dictum posuere.',
        description: 'Nam libero tempore, cum soluta nobis est eligendi optio qui cumque nihil impedit minus id quod maxime placeat facere.',
        author: 'Joseph Law',
        occupation: 'Fashion artist / Creative director',
        location: 'Russia',
        cover: images['zine-cover6.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar14.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9989,
        tint: 'white',
        type: '',
        accountType: 'fa',
        title: 'An e-Opening Concern',
        subtitle: 'Quisque interdum, odio vel dictum posuere.',
        description: '',
        author: 'Pressure Culture',
        occupation: 'Fashion company / Brand',
        location: 'Russia',
        cover: images['zine-cover8.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar11.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9988,
        tint: 'black',
        type: '',
        accountType: 'fa',
        title: 'Elements of Inspiration: Matthildur',
        subtitle: 'Quisque interdum, odio vel dictum posuere.',
        description: '',
        author: 'Lyn Slater',
        occupation: 'Fashion artist / Creative director',
        location: 'Russia',
        cover: images['zine-cover3.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar9.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9987,
        tint: 'white',
        type: '',
        accountType: 'fa',
        title: 'is fashion really going sustainable?',
        subtitle: 'Proin eget hendrerit magna. Sed tortor ligula, risus posuere ut porta vitae, sagittis in augue.',
        description: 'Excepteur sint occaecat cupidatat elitisius.',
        author: 'Joseph Law',
        occupation: 'Fashion artist / Creative director',
        location: 'Russia',
        cover: images['zine-cover4.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar14.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9986,
        tint: 'black',
        type: '',
        accountType: 'fa',
        title: 'How to make your closet more sustainable in 2023',
        subtitle: 'Aenean vitae risus ante laoreet erat varius.',
        description: '',
        author: 'Jessica Wang',
        occupation: 'Fashion lover',
        location: 'Russia',
        cover: images['zine-cover5.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar10.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9985,
        tint: 'pink',
        type: '',
        accountType: 'fa',
        title: 'latest campaign: how does fashion sound like?',
        subtitle: 'Quisque interdum, odio vel dictum posuere.',
        description: 'Nam libero tempore, cum soluta nobis est eligendi optio qui cumque nihil impedit minus id quod maxime placeat facere.',
        author: 'Joseph Law',
        occupation: 'Fashion artist / Creative director',
        location: 'Russia',
        cover: images['zine-cover6.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar14.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9984,
        tint: 'black',
        type: '',
        accountType: 'fa',
        title: 'sounds of a fashion revolution',
        subtitle: 'Curabitur condimentum quam eu erat faucibus, sit amet gravida odio pulvinar.',
        description: 'Itaque earum rerum hic tenetur a sapiente delectus.',
        author: 'Joseph Law',
        occupation: 'Fashion artist / Creative director',
        location: 'Russia',
        cover: images['zine-cover7.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar14.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9983,
        tint: 'white',
        type: '',
        accountType: 'fa',
        title: 'An e-Opening Concern',
        subtitle: 'Quisque interdum, odio vel dictum posuere.',
        description: '',
        author: 'Pressure Culture',
        occupation: 'Fashion company / Brand',
        location: 'Russia',
        cover: images['zine-cover8.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar11.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9982,
        tint: 'pink',
        type: '',
        accountType: 'fa',
        title: "What it's like to apply medicine on fashion.",
        subtitle: 'Aenean vitae risus ante laoreet erat varius.',
        description: '',
        author: "Luis D'oliviera",
        occupation: 'Fashion artist / Creative director, Photographer',
        location: 'Russia',
        cover: images['zine-cover9.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar12.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9981,
        tint: 'black',
        type: '',
        accountType: 'fa',
        title: 'pulling the masks off sustainability',
        subtitle: 'Aenean vitae risus ante laoreet erat varius.',
        description: 'Et harum quidem ut rerum facilis est et expedita ulit distinctio.',
        author: 'Joseph Law',
        occupation: 'Fashion artist / Creative director',
        location: 'Russia',
        cover: images['zine-cover10.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar14.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9980,
        tint: 'pink',
        type: '',
        accountType: 'fa',
        title: 'latest campaign: how does fashion sound like?',
        subtitle: 'Quisque interdum, odio vel dictum posuere.',
        description: 'Nam libero tempore, cum soluta nobis est eligendi optio qui cumque nihil impedit minus id quod maxime placeat facere.',
        author: 'Joseph Law',
        occupation: 'Fashion artist / Creative director',
        location: 'Russia',
        cover: images['zine-cover6.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar14.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9979,
        tint: 'white',
        type: '',
        accountType: 'fa',
        title: 'An e-Opening Concern',
        subtitle: 'Quisque interdum, odio vel dictum posuere.',
        description: '',
        author: 'Pressure Culture',
        occupation: 'Fashion company / Brand',
        location: 'Russia',
        cover: images['zine-cover8.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar11.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    },
    {
        id: 9978,
        tint: 'black',
        type: '',
        accountType: 'fa',
        title: "today's minds of fashion",
        subtitle: 'Orci varius natoque penatibus et magnisem.',
        description: 'Et harum quidem rerum facilis est et expedita distinctio.',
        author: 'Joseph Law',
        occupation: 'Fashion artist / Creative director',
        location: 'Russia',
        cover: images['zine-cover2.png'],
        coverCaption: 'Image caption aut vitae in Hadi Mousally, tellus venenatis Olivier Pagny.',
        body: `Morbi neque magna, posuere vel risus quis, eleifendis ornare libero. Nulla egestas mauris in velit ullamcorper, nec aliquet nunc gravida. Mauris vitae ex aliquet massa interdum convallis. Fusce feugiat dolor eget quam laoreet. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus.  Fusce vel pretium: <a href="" class="url-underline">Hadi Mousally</a>, <a href="" class="url-underline">Olivier Pagny</a> and <a href="" class="url-underline">Joseph Law</a>.
        <br/>
        <br/>
        <p class="pn-bold">Proin in velit ligula varius metus</p>
        Curabitur mollis interdum lacus, non aliquam nisl dapibus a. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ullamcorper ipsum felis, non ultrices libero viverra a. Suspendisse potenti. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. 
        Pellentesque tempus tortor erat, sed lacinia urna lobortis vellitiums ipsum dolor ac. Curabitur scelerisque ex sit amet mauris pharetra, et volutpat est rhoncus. Curabitur nec nibh est. Fusce at facilisis urna. Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. <a href="" class="url-underline">URL links are underlined</a>. Praesent semper dignissim purus, nec porttitor pretium. <a href="" class="url-underline">URL links turn pink on desktop hover and tap on mobile</a>.
        <br/>
        <br/>
        <p class="pn-bold">Fusce feugiat dolor eget quam blandit laoreet</p>
        Fusce fermentum justo sit amet urna faucibus, id aliquet neque dignissim. Suspendisse potenti. Praesent hendrerit sem nec tellus venenatis, et consectetur purus cursus. Curabitur sodales id metus in fringilla. Praesent semper dignissim purus, nec porttitor pretium maximus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`,
        profile: images['zine-avatar14.png'],
        date: '11 April 2022',
        tags: ['Pioneers', 'Interview', 'Creative Process', 'h7o7 Studio'],
        time: '4.56am'
    }
]

export const mentions = [
    {
        author: 'Alberto Lara',
        occupation: 'Fashion artist / Photographer',
        type: 'fa',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'black',
        cover: images['zine-avatar1.png']
    },
    {
        author: 'Jivomir Domouschiev mmmmmmmmmm mmmmmmmmmmmmmmmm',
        occupation: 'Fashion artist / Creative Director, Stylist, Designer oooooooooooooooo oooooooooooooooooo',
        type: 'fa',
        location: 'Singapore kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>  sssssss ssssssss sssssssss lllll ppppppppppp',
        profileLink: '',
        tint: 'pink',
        cover: images['zine-avatar2.png']
    },
    {
        author: 'Drizzle Agency',
        occupation: 'Fashion company / Agency',
        type: 'fc',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'pink',
        cover: images['zine-avatar3.png']
    },
    {
        author: 'Monica Ma',
        occupation: 'Fashion lover',
        type: 'fl',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'black',
        cover: images['zine-avatar4.png']
    },
    {
        author: 'Lalovenenoso',
        occupation: 'Fashion company / Brand',
        type: 'fa',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'pink',
        cover: images['zine-avatar5.png']
    },
    {
        author: 'Iva Ksenevich',
        occupation: 'Fashion artist / Designer',
        type: 'fc',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'black',
        cover: images['zine-avatar6.png']
    },
    {
        author: 'Bogdan Shirokov',
        occupation: 'Fashion lover',
        type: 'fl',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'pink',
        cover: images['zine-avatar7.png']
    },
    {
        author: 'Clara Parmigiani',
        occupation: 'Fashion artist / Photographer',
        type: 'fa',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'black',
        cover: images['zine-avatar8.png']
    },
    {
        author: 'Lorem ipsum',
        occupation: 'Lorem ipsum dolor sit amet',
        type: 'fc',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'pink',
        cover: images['zine-avatar4.png']
    },
    {
        author: 'Lorem ipsum',
        occupation: 'Quis nostrud exercitation ullamco',
        type: 'fl',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'black',
        cover: images['zine-avatar5.png']
    },
    {
        author: 'Alberto Lara',
        occupation: 'Fashion artist / Photographer',
        type: 'fa',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'pink',
        cover: images['zine-avatar1.png']
    },
    {
        author: 'Jivomir Domouschiev',
        occupation: 'Fashion artist / Creative Director, Stylist, Designer',
        type: 'fc',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'black',
        cover: images['zine-avatar2.png']
    },
    {
        author: 'Drizzle Agency',
        occupation: 'Fashion company / Agency',
        type: 'fl',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        cover: images['zine-avatar3.png']
    },
    {
        author: 'Monica Ma',
        occupation: 'Fashion lover',
        type: 'fa',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'pink',
        cover: images['zine-avatar4.png']
    },
    {
        author: 'Lalovenenoso',
        occupation: 'Fashion company / Brand',
        type: 'fc',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'black',
        cover: images['zine-avatar5.png']
    },
    {
        author: 'Iva Ksenevich',
        occupation: 'Fashion artist / Designer',
        type: 'fl',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'pink',
        cover: images['zine-avatar6.png']
    },
    {
        author: 'Bogdan Shirokov',
        occupation: 'Fashion lover',
        type: 'fa',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'black',
        cover: images['zine-avatar7.png']
    },
    {
        author: 'Clara Parmigiani',
        occupation: 'Fashion artist / Photographer',
        type: 'fc',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'pink',
        cover: images['zine-avatar8.png']
    },
    {
        author: 'Lorem ipsum',
        occupation: 'Lorem ipsum dolor sit amet',
        type: 'fl',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'black',
        cover: images['zine-avatar4.png']
    },
    {
        author: 'Lorem ipsum',
        occupation: 'Quis nostrud exercitation ullamco',
        type: 'fa',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'pink',
        cover: images['zine-avatar5.png']
    },
    {
        author: 'Drizzle Agency',
        occupation: 'Fashion company / Agency',
        type: 'fc',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'black',
        cover: images['zine-avatar3.png']
    },
    {
        author: 'Monica Ma',
        occupation: 'Fashion lover',
        type: 'fl',
        location: 'Singapore',
        statement: 'Fashion statement displays here et elitis commodo. Ut et elit in urna vellit efficitu. <a href="" class="url-underline">https://www.instagram.com/olivierrizzo/</a>',
        profileLink: '',
        tint: 'pink',
        cover: images['zine-avatar4.png']
    }
]

export const comments = [
    {
        id: 1111,
        parentId: null,
        author: 'Diego Marquis',
        type: 'fa',
        avatar: Avatar2,
        createdAt: new Date(2019, 9, 27, 15, 30),
        comment: 'Etiam felis nunc, ultricies id placerat siti digissim convalli ullamcorper. Aenean felis aut mollisimi magna eget nislimis vehicular.',
        responseDepth: 0,
        response: [
            {
                id: 1211,
                parentId: 1111,
                author: 'Joseph Law',
                type: 'fa',
                avatar: Avatar2,
                createdAt: new Date(2019, 9, 27, 15, 30),
                comment: 'Etiam felis nunc, ultricies id placerat siti digissim convalli ullamcorper. Aenean felis aut mollisimi magna eget nislimis vehicular.',
                responseDepth: 1,
                response: []
            },
            {
                id: 1311,
                parentId: 1111,
                author: 'user1',
                type: 'fc',
                avatar: Avatar2,
                // date: 'October 27, 2019',
                // time: '3.30pm',
                createdAt: new Date(2019, 9, 27, 15, 31),
                comment: 'Etiam felis nunc',
                responseDepth: 1,
                response: []
            },
            {
                id: 1411,
                parentId: 1111,
                author: 'user2',
                type: 'fl',
                avatar: Avatar2,
                createdAt: new Date(2019, 9, 27, 15, 35),
                comment: 'Etiam felis nunc',
                responseDepth: 1,
                response: []
            },
            {
                id: 1511,
                parentId: 1111,
                author: 'user1',
                type: 'fc',
                avatar: Avatar2,
                createdAt: new Date(2019, 9, 27, 15, 50),
                comment: 'Etiam felis nunc',
                responseDepth: 1,
                response: [
                    {
                        id: 1521,
                        parentId: 1511,
                        author: 'user1',
                        type: 'fc',
                        avatar: Avatar2,
                        createdAt: new Date(2019, 9, 27, 16, 10),
                        comment: 'Etiam felis nunc',
                        responseDepth: 2,
                        response: []
                    }
                ]
            }
        ]
    },
    {
        id: 2222,
        parentId: null,
        author: 'Diego Marquis',
        type: 'fa',
        avatar: Avatar2,
        createdAt: new Date(2019, 8, 2, 17, 30),
        comment: 'Etiam felis nunc.',
        responseDepth: 0,
        response: []
    },
    {
        id: 3333,
        parentId: null,
        author: 'Diego Marquis',
        type: 'fa',
        avatar: Avatar2,
        createdAt: new Date(2018, 8, 2, 15, 30),
        comment: 'Etiam felis nunc.',
        responseDepth: 0,
        response: []
    },
    {
        id: 4444,
        parentId: null,
        author: 'Joseph Law',
        type: 'fa',
        avatar: Avatar2,
        createdAt: new Date(2018, 8, 2, 10, 30),
        comment: 'Etiam felis nunc, ultricies id placerat siti digissim convalli ullamcorper. Aenean felis aut mollisimi magna eget nislimis vehicular.',
        responseDepth: 0,
        response: []
    }
]